module.exports = __webpack_public_path__ + "img/content6-12.2933c67a.webp";